var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        margin: 0,
        border: 0,
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        userSelect: 'none',
    },
    horizontal: {
        width: '100%',
        borderTopWidth: theme.shape.borderWidth.normal,
        '&$thin': {
            borderTopWidth: theme.shape.borderWidth.thin,
        },
        '&$inset': {
            margin: theme.spacing(0, 1),
            width: "calc(100% - " + theme.spacing(2) + "px)",
        },
    },
    vertical: {
        height: '100%',
        borderLeftWidth: theme.shape.borderWidth.normal,
        '&$thin': {
            borderLeftWidth: theme.shape.borderWidth.thin,
        },
        '&$inset': {
            margin: theme.spacing(1, 0),
            height: "calc(100% - " + theme.spacing(2) + "px)",
        },
    },
    inset: {},
    thin: {},
}); }, { name: 'SnDivider' });
/**
 * 区切り線コンポーネント。
 */
export var Divider = function (props) {
    var _a;
    var vertical = props.vertical, thin = props.thin, inset = props.inset, thickness = props.thickness, color = props.color, className = props.className, propStyle = props.style;
    var classes = useStyles(props);
    var hrClassNames = classNames((_a = {},
        _a[classes.root] = true,
        _a[classes.thin] = thickness == null && thin,
        _a[classes.horizontal] = !vertical,
        _a[classes.vertical] = vertical,
        _a[classes.inset] = inset,
        _a), className);
    var style = useMemo(function () {
        if (thickness == null)
            return propStyle;
        if (vertical)
            return __assign({ borderLeftWidth: thickness + "px" }, propStyle);
        return __assign({ borderTopWidth: thickness + "px" }, propStyle);
    }, [propStyle, thickness, vertical]);
    return React.createElement("hr", { className: hrClassNames, style: style, color: color });
};
